import React, { useState } from "react";

import { Button, Card, List } from "antd";

import AddDeviceModal from "./components/AddDeviceModal";
import Item from "./components/Item";

const WorkerDevices = ({ data = [], refetch, ref2 }) => {
  const [is_open_add_worker_modal, setOpenAddDeviceModal] = useState(false);

  return (
    <Card
      style={{ marginBottom: 24 }}
      title="Dostępne urządzenia"
      styles={{
        body: { padding: 0 },
      }}
      extra={
        <Button onClick={() => setOpenAddDeviceModal(true)}>
          Przypisz urządzenie
        </Button>
      }
    >
      {is_open_add_worker_modal && (
        <AddDeviceModal
          worker_devices={data}
          refetch={refetch}
          handleClose={() => setOpenAddDeviceModal(false)}
        />
      )}
      <List
        dataSource={data?.sort((a, b) => a.id - b.id)}
        renderItem={(props) => (
          <Item {...props} refetch={refetch} ref2={ref2} />
        )}
      />
    </Card>
  );
};

export default WorkerDevices;
